<template>
  <div class="container">
    <div
      class="loader"
      v-if="!seriesLoaded"
    >
    </div>
    <div
      class="grid grid_h-center grid_v-margins"
      v-else
    >
      <div class="grid__col grid__col_xl-20">
        <div class="section__header">
          <h2>{{ $t('series_events.title') }}</h2>
          <div class="section__subheader">
            <sort
              :active="sort.val"
              :options="sort.options"
              @change="changeSort"
            >
              <div
                slot="extra"
                class="rr-buttons-group rr-buttons-group_solid d-none d-md-block"
              >
                <Button
                  v-for="item in view.options"
                  :key="item.id"
                  :variant="view.val === item.id ? 'ghost' : 'secondary'"
                  size="sm"
                  :class="{
                    'rr-buttons-group__active': view.val === item.id,
                  }"
                  :text="item.name"
                  style="background: white"
                  @click="changeView(item.id)"
                ></Button>
              </div>
            </sort>
          </div>
        </div>
        <EventsMap
          v-show="view.val === 'map'"
          ref="eventsMap"
          :eventsType="sort.val === 'all' ? null : sort.val"
          @updateQuery="setQuery"
        >
        </EventsMap>
        <EventsList
          v-show="view.val === 'list'"
          ref="eventsList"
          :eventsType="sort.val === 'all' ? null : sort.val"
          @updateQuery="setQuery"
        >
          <template v-slot:noResults>
            <br>
            <div class="block block_wide">
              <div class="empty-state">
                <div class="section__group mt-0">
                  <div class="section__item">
                    <img :src="themeImages['finish-line']" alt="" width="322">
                  </div>
                  <div class="section__item">
                    <div class="text-lg"><b v-html="emptyText.title"></b></div>
                    <div class="mt-8" v-if="emptyText.text" v-html="emptyText.text"></div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </EventsList>
      </div>
    </div>
    <OfflineRegModal></OfflineRegModal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Sort from '@/components/Sort.vue';
import EventsList from '@/components/EventsList.vue';
import EventsMap from '@/components/EventsMap.vue';
import OfflineRegModal from '@/components/OfflineRegModal.vue';

export default {
  name: 'Series',
  components: {
    Sort,
    EventsList,
    EventsMap,
    OfflineRegModal,
  },
  props: {
    seriesLoaded: Boolean,
  },
  data() {
    return {
      filtersId: +new Date(),
      events: [],
      view: {
        val: 'list',
        options: [
          {
            id: 'list',
            name: this.$t('events.nav.listView'),
            icon: 'unordered-list',
          },
          {
            id: 'map',
            name: this.$t('events.nav.mapView'),
            icon: 'map',
          },
        ],
      },
      sort: {
        val: 'all',
        options: [
          { id: 'all', name: 'Все' },
          { id: '0', name: this.$t('events.nav.future') },
          { id: '3', name: this.$t('events.nav.virtual') },
          { id: '2', name: this.$t('events.nav.results') },
        ],
      },
    };
  },
  computed: {
    ...mapGetters('settings', ['themeImages']),
    emptyText() {
      switch (this.sort.val) {
        case '0':
          return {
            title: this.$t('series_events.empty_upcoming'),
            text: this.$t('series_events.empty_upcoming_text'),
          };
        case '3':
          return {
            title: this.$t('series_events.empty_virtual'),
          };
        case '2':
          return {
            title: this.$t('series_events.empty_results'),
            text: this.$t('series_events.empty_results_text'),
          };
        default:
          return {
            title: this.$t('series_events.empty'),
          };
      }
    },
  },
  methods: {
    changeView(id) {
      if (this.view.val === id) {
        return;
      }
      this.view.val = id;
      this.$refs.eventsList.toggle(id === 'list', this.filtersId);
      this.$refs.eventsMap.toggle(id === 'map', this.filtersId);
    },
    changeSort(value) {
      if (value && value.id === this.sort.val) {
        return;
      }
      this.sort.val = value.id;
      this.changeFilters();
    },
    getFiltersRequestParams() {
      return {
        SportSeriesCode: this.$route.params.seriesCode,
      };
    },
    parseQuery() {
      const { query } = this.$route;

      if (query.p) {
        this.$refs.eventsList.pagination.page = +query.p;
      }

      if (query.e) {
        this.sort.val = query.e;
      }
    },
    setQuery() {
      setTimeout(() => {
        const query = {};

        const { page } = this.$refs.eventsList.pagination;
        if (page > 0) {
          query.p = page;
        }

        if (this.sort.val !== 'all') {
          query.e = +this.sort.val;
        }

        this.$router.replace({
          query,
        }).catch(() => {});
      });
    },
    changeFilters() {
      this.filtersId += 1;

      setTimeout(() => {
        if (this.view.val === 'list') {
          this.$refs.eventsList.onFiltersChange({}, this.filtersId);
        } else if (this.view.val === 'map') {
          this.$refs.eventsMap.onFiltersChange({}, this.filtersId);
        }
      });
    },
  },
  watch: {
    seriesLoaded: {
      handler(val) {
        if (val) {
          this.changeFilters();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.parseQuery();
  },
};
</script>
